import { createUseStyles } from 'react-jss';
import { Classes } from 'jss';

export const useCalendarStyles: (data?: { theme?: Jss.Theme }) => Classes<'root' | 'days'> = createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  days: {
    display: 'grid',
    gap: '2px 0px',
    gridAutoRows: '32px',
    gridTemplateColumns: 'repeat(7, 32px)',
    width: `${7 * 32}px`,
  },
});
